// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-circular {
  --color: var(--ion-color-primary);
}
.loader-circular.spinner-xsmall {
  width: 25px;
  height: 25px;
}
.loader-circular.spinner-xsmall font {
  size: 25px;
}
.loader-circular.spinner-small {
  width: 50px;
  height: 50px;
}
.loader-circular.spinner-small font {
  size: 50px;
}
.loader-circular.spinner-medium {
  width: 75px;
  height: 75px;
}
.loader-circular.spinner-medium font {
  size: 75px;
}
.loader-circular.spinner-large {
  width: 100px;
  height: 100px;
}
.loader-circular.spinner-large font {
  size: 100px;
}
.loader-circular.spinner-xlarge {
  width: 125px;
  height: 125px;
}
.loader-circular.spinner-xlarge font {
  size: 125px;
}`, "",{"version":3,"sources":["webpack://./src/components/general components/loader-circular/loader-circular.component.scss","webpack://./src/components/general%20components/loader-circular/loader-circular.component.scss"],"names":[],"mappings":"AAAA;EACE,iCAAA;ACCF;ADCE;EAGE,WAFO;EAGP,YAHO;ACEX;ADGI;EACE,UANK;ACKX;ADKE;EAGE,WAFO;EAGP,YAHO;ACFX;ADOI;EACE,UANK;ACCX;ADSE;EAGE,WAFO;EAGP,YAHO;ACNX;ADWI;EACE,UANK;ACHX;ADaE;EAGE,YAFO;EAGP,aAHO;ACVX;ADeI;EACE,WANK;ACPX;ADiBE;EAGE,YAFO;EAGP,aAHO;ACdX;ADmBI;EACE,WANK;ACXX","sourcesContent":[".loader-circular {\n  --color: var(--ion-color-primary);\n\n  &.spinner-xsmall {\n    $size: 25px;\n\n    width: $size;\n    height: $size;\n\n    font {\n      size: $size;\n    }\n  }\n\n  &.spinner-small {\n    $size: 50px;\n\n    width: $size;\n    height: $size;\n\n    font {\n      size: $size;\n    }\n  }\n\n  &.spinner-medium {\n    $size: 75px;\n\n    width: $size;\n    height: $size;\n\n    font {\n      size: $size;\n    }\n  }\n\n  &.spinner-large {\n    $size: 100px;\n\n    width: $size;\n    height: $size;\n\n    font {\n      size: $size;\n    }\n  }\n\n  &.spinner-xlarge {\n    $size: 125px;\n\n    width: $size;\n    height: $size;\n\n    font {\n      size: $size;\n    }\n  }\n}\n",".loader-circular {\n  --color: var(--ion-color-primary);\n}\n.loader-circular.spinner-xsmall {\n  width: 25px;\n  height: 25px;\n}\n.loader-circular.spinner-xsmall font {\n  size: 25px;\n}\n.loader-circular.spinner-small {\n  width: 50px;\n  height: 50px;\n}\n.loader-circular.spinner-small font {\n  size: 50px;\n}\n.loader-circular.spinner-medium {\n  width: 75px;\n  height: 75px;\n}\n.loader-circular.spinner-medium font {\n  size: 75px;\n}\n.loader-circular.spinner-large {\n  width: 100px;\n  height: 100px;\n}\n.loader-circular.spinner-large font {\n  size: 100px;\n}\n.loader-circular.spinner-xlarge {\n  width: 125px;\n  height: 125px;\n}\n.loader-circular.spinner-xlarge font {\n  size: 125px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
